import type { FaireProductEntity } from "../../entity_types/product";

export const p_wakdtz4x8r: FaireProductEntity = {
  token: "p_wakdtz4x8r",
  type: "product",
  name: "Soy Wax Scented Beads - 2lb Refill for A La Carte Candle Bar",
  brandName: "Milkhouse Candle Company",
  imageUrl:
    "https://cdn.faire.com/fastly/52383c3336270d1b854de1f99cedb780a7ab592fc42c5f8b0ac241f2b14e148a.jpeg",
  priceDollars: 0,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/132a3ce9d8cee295b610eb4edf2c0fed691642fd2033749a3f716a1cb4760d11.png",
  weight: 1,
  dimensions: {
    width: 6,
    height: 6,
    depth: 4,
  },
  inStock: true,
};
